import { getRgObjectsOfType as r, RG_TYPE as m } from "@project-rouge/rg-core";
import { getArea as s } from "../index3.js";
const c = (e) => {
  const a = s(e);
  return a === 0 ? 0 : r(e, m.Apartment).map((t) => t.data.habitableRooms).reduce((t, o) => t + o, 0) / a;
};
export {
  c as getDensityHabitableRooms
};
//# sourceMappingURL=index14.js.map
